// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// ANTD
import Carousel from 'antd/lib/carousel';
import Icon from 'components/common/Icon';
import 'antd/lib/carousel/style/css';

const ICON_STYLE = {
  fontSize: 30,
  color: '#BEE0EB',
  position: 'absolute',
  fontWeight: 800,
  bottom: '50%',
  cursor: 'pointer',
};

const Container = styled.div`
  margin: 0 auto;
  position: relative;
  .slick-slide {
    text-align: center;
    width: 100%;
    height: 625px;
    max-height: 625px; // height: 160px;
    img {
      max-width: 100%;
    }
  }
  .slick-dots {
    display: block !important;
    height: 20px;
    bottom: 40px;
    li {
      margin: 0 12px;
      background: #bee0eb;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      button {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background: #bee0eb;
        &:hover {
          opacity: 1;
        }
      }
      &.slick-active {
        background: #3584b1;
        button {
          opacity: 1;
          background: #3584b1;
          width: 10px;
          height: 10px;
          border-radius: 5px;
        }
      }
    }
  }
`;

class CarouselSection extends React.PureComponent {
  componentDidMount() {}

  render() {
    return (
      <Container>
        <Icon
          type="left"
          style={{ ...ICON_STYLE, ...{ left: -10 } }}
          onClick={() => {
            if (this.slider) {
              return this.slider.prev();
            }
          }}
        />
        <Carousel
          dots
          autoplay
          style={{ border: '3px solid blue' }}
          autoplaySpeed={7000}
          infinite
          arrows
          accessibility
          ref={node => (this.slider = node)}
        >
          <div>
            <img src="https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883618/cclariti/Bubbles1.png" alt="" />
          </div>
          <div>
            <img src="https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883617/cclariti/Bubbles2.png" alt="" />
          </div>
          <div>
            <img src="https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883617/cclariti/Bubbles3.png" alt="" />
          </div>
          <div>
            <img src="https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883617/cclariti/Bubbles4.png" alt="" />
          </div>
          <div>
            <img src="https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883617/cclariti/Bubbles5.png" alt="" />
          </div>
        </Carousel>
        <Icon
          type="right"
          style={{ ...ICON_STYLE, ...{ right: -10 } }}
          onClick={() => {
            if (this.slider) {
              return this.slider.next();
            }
          }}
        />
      </Container>
    );
  }
}

export default CarouselSection;



// WEBPACK FOOTER //
// ./src/routes/app-home/CarouselSection/index.js